import ConsultaListView from './views/ConsultaListView.vue'
import ConsultaCreateView from './views/ConsultaCreateView.vue'
import ConsultaView from './views/ConsultaView.vue'

export default [
  {
    path: '/consultas',
    name: 'consultas',
    component: ConsultaListView
  },
  {
    path: '/consulta-nueva',
    name: 'nuevaConsulta',
    component: ConsultaCreateView
  },
  {
    path: '/consulta-detalle/:id',
    name: 'detalleConsulta',
    component: ConsultaView
  }
]
